import GfyCatItem from '../../lib/GfyCatItem';
import * as videojs from 'video.js';

export default class Masthead {
	private readonly mastheadEl: HTMLVideoElement;
	private readonly jsonUrl: string;
	private options = {
		preload: 'auto',
		autoplay: true,
		loop: true,
		muted: true,
		controls: false,
		sources: [] as any[]
	};

	constructor(videoId: string) {
		this.mastheadEl = document.getElementById(videoId) as HTMLVideoElement;
		if (!this.mastheadEl)
			return;

		this.jsonUrl = this.getGfyCatAjaxUrl(this.mastheadEl.getAttribute('data-json'));
		this.fetchVideo(this.jsonUrl);
	}

	private getGfyCatAjaxUrl(url: string): string {
		const idRegex = /(?:.(?!\/))+$/;
		return `https://api.gfycat.com/v1/gfycats/${idRegex.exec(url)[0].substr(1)}`;
	}

	private fetchVideo(jsonUrl: string): void {
		fetch(jsonUrl)
			.then((response: Response) => {
				if (response.ok) {
					return response.json();
				} else {
					return Promise.reject(new Error(response.statusText));
				}
			}).then((response) => {
				const gfyCatItem: GfyCatItem = response.gfyItem;
				if (gfyCatItem.webmUrl) {
					this.options.sources.push({
						src: gfyCatItem.webmUrl,
						type: 'video/webm'
					});
				}
				if (gfyCatItem.mp4Url) {
					this.options.sources.push({
						src: gfyCatItem.mp4Url,
						type: 'video/mp4'
					});
				}
				(videojs as any)(this.mastheadEl, this.options); // The type definitions provided by VideoJS are completely wrong, so we have to do this nonsense.
			}).catch((error: Error) => {
				console.warn('The masthead video could not be loaded.', error);
			});
	}
}
